import { useState } from 'react';
import { hasCoarsePointer } from '@/shared/utils/pointer';

interface NavigatorWithUserAgentData extends Navigator {
  userAgentData?: { mobile?: boolean };
}

function popupsAreReliable(): boolean {
  const mobile = (navigator as NavigatorWithUserAgentData).userAgentData?.mobile;
  if (mobile !== undefined) return !mobile;

  return !hasCoarsePointer();
}

export function usePopupCapability(): boolean {
  const [reliable] = useState(popupsAreReliable);

  return reliable;
}
